import type { AxiosResponse } from 'axios'
import axios from 'axios'

import environment from '@/environment'
import type { FlexBalanceResource, FlexBalanceResourcePage } from '@/features/flexBalance/types'
import type { Resource } from '@/features/resource/types'

const BASE_RESOURCES_API_URL = `${environment.services.resourcesManagerApiUrl}/resources`
const FLEXBALANCE_RESOURCE_STEERING_API = `${environment.services.flexBalanceApiUrl}/resource-steering`

export const FLEX_BALANCE_RESOURCE_API_URL = 'flexBalanceResource'

export function steerResource(continuousSteering: boolean): Promise<AxiosResponse<void, string>> {
  const url = `${FLEXBALANCE_RESOURCE_STEERING_API}/steer`
  return axios.post<void, AxiosResponse<void, string>>(url, { continuousSteering })
}

export function releaseResource(): Promise<AxiosResponse<void, string>> {
  const url = `${FLEXBALANCE_RESOURCE_STEERING_API}/unsteer`
  return axios.post<void, AxiosResponse<void, string>>(url, {})
}

export async function getFlexBalanceResourceValues(): Promise<FlexBalanceResourcePage> {
  const resourceId = '73fc051e-dad6-4189-81a1-90e0d221b1b1'
  const response = await axios.get(`${BASE_RESOURCES_API_URL}/${resourceId}`)
  const { resourceName, customerName, resourceID, steeringStatus } = response.data.resourceResponse as Resource

  const resources: FlexBalanceResource[] = [
    {
      name: resourceName ?? '',
      site: customerName ?? '',
      resourceId: resourceID,
      steeringStatus: steeringStatus ?? null,
    },
  ]

  return {
    values: resources,
    currentPage: 0,
    totalCount: resources.length,
  }
}
